import chefcookie from 'chefcookie'
/* Merged Plone Javascript file
 * This file is dynamically assembled from separate parts.
 * Some of these parts have 3rd party licenses or copyright information attached
 * Such information is valid for that section,
 * not for the entire composite file
 * originating files are separated by - filename.js -
 */

class prprenotachefcookie extends chefcookie {
  showSettings () {
    this.logTracking('settings_open')
    let el = document.querySelector('.chefcookie__settings-container')
    el.classList.add('chefcookie__settings-container--visible')
    el.style.minHeight = el.scrollHeight + 'px'
    setTimeout(() => {
      if (el.classList.contains('chefcookie__settings-container--visible')) {
        el.style.height = 'auto'
      }
    }
    , this.animationSpeed)
    this.fixMaxHeight()
  }
  acceptAllScripts () {
    let providers = []
    this.config.settings.forEach(settings__value => {
      if (settings__value.scripts !== undefined) {
        Object.entries(settings__value.scripts).forEach(([scripts__key, scripts__value]) => {
          this.accept(scripts__key, false)
        }
        )
      }
    }
    )
  }
  switchSettingsLabelsOpen () {
    document.querySelector('.chefcookie__button--accept').style.display = 'block'
    document.querySelector('.chefcookie__button--settings').style.display = 'none'
  }
  buildDom () {
    document.body.insertAdjacentHTML('afterbegin', `<div id="cc-banner" class="chefcookie chefcookie--${this.config.style.layout} chefcookie--columns-${'columns' in this.config.style ? this.config.style.columns : 'auto'}${'scripts_selection' in this.config && this.config.scripts_selection !== false ? ` chefcookie--has-scripts` : ``} chefcookie--hidden"><div class="chefcookie__inner"><div class="chefcookie__box"><a data-cc-destroy href="#" class="close"></a><div class="chefcookie__message">${this.translate(this.config.message)}</div><div class="chefcookie__settings-container"><ul class="chefcookie__groups chefcookie__groups--count-${this.config.settings.length}">${this.config.settings.map((group, i) => `<li class="chefcookie__group${group.cannot_be_modified ? ` chefcookie__group--disabled` : ``}"><label class="chefcookie__group-label" for="chefcookie_group_${i}"><input${group.cannot_be_modified ? ` disabled="disabled"` : ``} class="chefcookie__group-checkbox" data-status="${this.isCheckboxActiveForGroup(i)}" id="chefcookie_group_${i}" type="checkbox" name="chefcookie_group[]" value="${i}"${this.isCheckboxActiveForGroup(i) === 2 ? ` checked="checked"` : ``}/><span class="chefcookie__group-title">${this.translate(group.title)}</span><span class="chefcookie__group-checkbox-icon"></span>${'description' in group && group.description != '' ? `<span class="chefcookie__group-description">${this.translate(group.description)}</span>` : ``}
${'scripts_selection' in this.config && this.config.scripts_selection === 'collapse' && 'scripts' in group && Object.keys(group.scripts).length > 0 && Object.keys(group.scripts)[0].indexOf('dummy_') === -1 ? `<a href="#" class="chefcookie__group-collapse">${this.getLabel('group_open') != '' ? this.getLabel('group_open') : this.getLabel('settings_open')}</a>` : ``}</label>${'scripts_selection' in this.config && this.config.scripts_selection !== false && 'scripts' in group && Object.keys(group.scripts).length > 0 && Object.keys(group.scripts)[0].indexOf('dummy_') === -1 ? `<ul class="chefcookie__scripts chefcookie__scripts--count-${Object.keys(group.scripts).length}${this.config.scripts_selection !== 'collapse' ? ` chefcookie__scripts--visible` : ``}">${Object.keys(group.scripts).map(j => `<li class="chefcookie__script${group.cannot_be_modified ? ` chefcookie__script--disabled` : ``}"><label class="chefcookie__script-label" for="chefcookie_script_${i}_${j}"><input${group.cannot_be_modified ? ` disabled="disabled"` : ``} class="chefcookie__script-checkbox" id="chefcookie_script_${i}_${j}" type="checkbox" name="chefcookie_script[]" value="${i}|${j}"${this.isCheckboxActiveForProvider(i, j) ? ` checked="checked"` : ``}/><span class="chefcookie__script-title">${typeof group.scripts[j] === 'object' && group.scripts[j] !== null && 'title' in group.scripts[j] && group.scripts[j].title != '' ? this.translate(group.scripts[j].title) : j}</span><span class="chefcookie__script-checkbox-icon"></span></label>${typeof group.scripts[j] === 'object' && group.scripts[j] !== null && 'description' in group.scripts[j] && group.scripts[j].description != '' ? '<div class="chefcookie__script-description">' + '<a href="#" class="chefcookie__script-description-collapse">' + this.getLabel('details_open') + '</a>' + '<div class="chefcookie__script-description-content">' + this.translate(group.scripts[j].description) + '</div>' + '</div>' : ''}</li>`).join('')}</ul>` : ``}</li>`).join('')}</ul></div><div class="chefcookie__buttons chefcookie__buttons--count-${'show_decline_button' in this.config && this.config.show_decline_button === true ? '3' : '2'}"><a href="#chefcookie__decline" class="chefcookie__button chefcookie__button--decline">${this.getLabel('decline')}</a></div></div></div></div>`)
  }
}

/* - cookie_config.js - */
// https://www.pr.camcom.it/portal_javascripts/cookie_config.js?original=1
var iframeCookies = ['youtube', 'facebook']
var anchorCookies = ['twitter']
var profiling_cookies_config = {
  'checked_by_default': false,
  'cannot_be_modified': false,
  'initial_tracking': false,
  'domain': 'comune.parma.it',
  'title': {
    'en': 'Profiling Cookies',
    'it': 'Cookie di profilazione'
  },
  'description': {
    'en': "<p>The site uses profiling cookies to analyze user behavior and choices in order to propose targeted content corresponding to the user's profile. These cookies can only be installed upon your prior consent. Disallowing these cookies, some contents may not be available.</p>",
    'it': "<p>Il sito utilizza cookie di profilazione per analizzare il comportamento e le scelte degli utenti al fine di proporre contenuti mirati corrispondenti al profilo dell'utente. Questi cookie possono essere installati solamente dietro tuo consenso. Il blocco di questi cookie potrebbe impedire la visualizzazione di particolari contenuti del sito.</p>"
  },
  'scripts': {
    'youtube': {
      'title': {
        'en': 'YouTube',
        'it': 'YouTube'
      },
      'description': {
        'en': '<p>YouTube cookies are installed only if you play one of our embedded videos. The cookies are used to store information about the videos played and other information related to the player.</p>',
        'it': '<p>I cookie di YouTube vengono installati solo se riproduci uno dei nostri video incorporati. I cookie vengono utilizzati per memorizzare informazioni sui video riprodotti e altre informazioni relative al lettore.</p>'
      }
    },
    'facebook': {
      'title': {
        'en': 'Facebook',
        'it': 'Facebook'
      },
      'description': {
        'en': '<p>This cookie is used by Facebook to show relevant advertising when navigating Facebook products.</p>',
        'it': '<p>Questo cookie viene utilizzato da Facebook per mostrare pubblicit\u00e0 pertinente durante la navigazione dei prodotti Facebook.</p>'
      }
    }
  }
}
function accept_anchor_based_provider (cc, placeholder_identifier) {
  document.querySelectorAll('div.' + placeholder_identifier).forEach(function (placeholder) {
    var anchor = placeholder.nextElementSibling
    var twitter = anchor.nextElementSibling
    var anchor_href = anchor.dataset.ccHref
    var twitter_src = twitter.dataset.ccSrc
    var name = anchor.dataset.ccName
    if (cc.isAccepted(name)) {
      anchor.setAttribute('href', anchor_href)
      anchor.removeAttribute('hidden')
      twitter.removeAttribute('hidden')
      twitter.setAttribute('src', twitter_src)
      placeholder.setAttribute('hidden', true)
    }
  })
}
function decline_anchor_based_provider (cc, placeholder_identifier) {
  debugger
}
function accept_twitter_timeline (cc) {
  var placeholder_identifier = 'twittertimeline-placeholder'
  accept_anchor_based_provider(cc, placeholder_identifier)
}
function decline_twitter_timeline (cc) {
  var placeholder_identifier = 'twittertimeline-placeholder'
  decline_anchor_based_provider(cc, placeholder_identifier)
}
function accept_iframe (cc) {
  document.querySelectorAll('iframe').forEach(function (iframe) {
    var src = iframe.dataset.ccSrc
    var name = iframe.dataset.ccName
    var placeholder = iframe.previousElementSibling
    if (placeholder && src) {
      if (cc.isAccepted(name)) {
        iframe.setAttribute('src', src)
        iframe.removeAttribute('hidden')
        placeholder.setAttribute('hidden', true)
      } else {
        iframe.setAttribute('src', '')
        iframe.setAttribute('hidden', true)
        placeholder.removeAttribute('hidden')
      }
    }
  })
}
if (Object.keys(profiling_cookies_config).length > 0) {
  var has_hotjar = false
  iframeCookies.forEach(function (name) {
    if (profiling_cookies_config.scripts[name] !== undefined) {
      profiling_cookies_config.scripts[name].accept = (cc, resolve, isInit) => {
        accept_iframe(cc)
        if (name === 'facebook' && profiling_cookies_config.scripts[name].id) {
          let script = document.createElement('script')
          script.innerHTML = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '" + profiling_cookies_config.scripts[name].id + "');fbq('track', 'PageView');fbq('track', 'ViewContent');"
          document.head.appendChild(script)
          window.chefcookie_loaded.push(name)
        }
      }
    }
  })
  anchorCookies.forEach(function (name) {
    if (profiling_cookies_config.scripts[name] !== undefined) {
      profiling_cookies_config.scripts[name].accept = (cc, resolve, isInit) => {
        if (name === 'twittertimeline') {
          accept_twitter_timeline(cc)
        }
      }

      profiling_cookies_config.scripts[name].decline = (provider) => {
        decline_twitter_timeline(cc)
      }
    }
  })
  if (has_hotjar) {
    var hjLabels = {
      'title': {
        'en': 'HotJar',
        'it': 'Hotjar'
      },
      'description': {
        'en': "<p>Hotjar is a technology service that helps us better understand our users' navigation (e.g. how much time users  spend on which pages, which links users choose to click, etc.) and this enables us to build and maintain our service with user feedback.</p>",
        'it': '<p>Hotjar \u00e8 un servizio che ci aiuta a comprendere meglio la navigazione dei nostri utenti (ad es. quanto tempo gli utenti trascorrono su quali pagine, su quali collegamenti gli utenti scelgono di fare clic, ecc.) e questo ci consente di creare e mantenere il nostro servizio con il feedback degli utenti.</p>'
      }
    }
    profiling_cookies_config.scripts.hotjar = {
      id: "''",
      title: hjLabels.title,
      description: hjLabels.description,
      accept: function (cc, resolve, isInit) {
        var id = cc.config.settings[1].scripts.hotjar.id
        var script = document.createElement('script')
        script.innerHTML = '(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:' + id + ",hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')"
        document.head.appendChild(script)
        cc.setLoaded('hotjar')
      }
    }
  }
}
var cookies_settings = []
var technical_cookies = {
  'checked_by_default': true,
  'cannot_be_modified': true,
  'initial_tracking': true,
  'title': {
    'en': 'Technical Cookies',
    'it': 'Cookie tecnici'
  },
  'description': {
    'en': 'These cookies are strictly necessary for the website to work or for you to use requested services.',
    'it': 'Il sito utilizza cookie tecnici per analizzare il traffico da e verso il sito. I cookie tecnici consento anche di fornire un migliore servizio di navigazione sul sito, e raccolgono informazioni di navigazione a questo scopo.'
  },
  'scripts': {
    'techcookies': {
      'title': {
        'en': 'Functional Cookies',
        'it': 'Cookie funzionali'
      },
      'description': {
        'en': '<p>We use functionality cookies to enable specific website functions and to configure the Website depending on your choices.</p>',
        'it': '<p>Utilizziamo cookie funzionali per abilitare specifiche funzionalit\u00e0 del sito e per configurarlo a seconda delle tue scelte.</p>'
      }
    }
  }
}
if (Object.keys(technical_cookies).length > 0) {
  cookies_settings.push(technical_cookies)
}
if (Object.keys(profiling_cookies_config).length > 0) {
  cookies_settings.push(profiling_cookies_config)
}
var cc = new prprenotachefcookie({

  domain: '',
  message: {
    'en': '<h2>We use cookies</h2><p>This site uses technical cookies necessary for the proper functioning of the pages, and third-party profiling cookies. By selecting <b>Allow all</b> you are consenting to the use of analytics and profiling cookies. By closing the banner, only the technical cookies necessary for navigation will be used and some contents may not be available. For more information, please read our <a href="https://www.comune.parma.it/it/informazioni-generali/cookie-policy-del-portale-del-comune-di-parma" target="_blank">Cookie Policy</a>.</p>',
    'it': `<h2>Usiamo i cookies</h2>
        <p>Questo sito utilizza cookie tecnici necessari al corretto funzionamento 
        delle pagine, e cookie di profilazione di terze parti. 
        Chiudendo il banner verranno utilizzati solo i cookie tecnici necessari 
        alla navigazione e alcuni contenuti potrebbero non essere disponibili.</p>
        <p>Per maggiori informazioni, ti invitiamo a consultare la nostra  <a href="https://www.comune.parma.it/it/informazioni-generali/cookie-policy-del-portale-del-comune-di-parma" target="_blank">Cookie Policy</a>.
        </p>
        <p><strong>Cookie tecnici</strong></p>
        <p>Il sito utilizza cookie tecnici per analizzare il traffico da e verso il sito. 
        I cookie tecnici consento anche di fornire un migliore servizio di navigazione 
        sul sito, e raccolgono informazioni di navigazione a questo scopo.
        </p>
        <p><strong>Matomo</strong></p>
        <p>I cookie di Matomo sono usati per analizzare la navigazione 
        sul sito al fine di migliorarla e fornire all'utente un'esperienza di 
        navigazione migliore possibile.
        </p>
        `
  },
  accept_all_if_settings_closed: true,
  show_decline_button: true,
  scripts_selection: true,
  debug_log: true,
  consent_tracking: null,
  expiration: 180,
  exclude_google_pagespeed: false,
  style: {
    layout: 'bottombar',
    size: 1,
    color_text: '#4d4d4d',
    color_highlight: '',
    color_background: '#eeeeee',
    highlight_accept: true,
    show_disabled_checkbox: true,
    noscroll: false,
    fade: true,
    blur: true,
    css_add: ''
  },
  labels: {
    'accept': {
      'en': 'Save and continue',
      'it': 'Salva e continua'
    },
    'accept_all': {
      'en': 'Allow all',
      'it': 'Accetta tutto'
    },
    'settings_open': {
      'en': 'Personalizza',
      'it': 'Personalizza'
    },
    'settings_close': {
      'en': 'Close settings',
      'it': 'Chiudi impostazioni'
    },
    'group_open': {
      'en': 'Show more information',
      'it': 'Mostra altre informazioni'
    },
    'group_close': {
      'en': 'Close more information',
      'it': 'Chiudi altre informazioni'
    },
    'decline': {
      'en': 'Technical cookies only',
      'it': 'Solo cookie tecnici'
    },
    'details_open': {
      'en': 'Show details',
      'it': 'Mostra dettagli'
    },
    'details_close': {
      'en': 'Close details',
      'it': 'Chiudi dettagli'
    }
  },
  exclude: [() => {
    return (document.cookie !== undefined && document.cookie.indexOf('wp-settings-time') > -1)
  }
  ],
  settings: cookies_settings
})
document.addEventListener('DOMContentLoaded', () => {
  cc.init()
  accept_iframe(cc)
  document.querySelectorAll('.pat-tiles-management').forEach(el => {
    el.addEventListener('rtTilesLoaded', e => {
      accept_iframe(cc)
    }
    )
  }
  )
  cc.registerEventListener(document, 'click', e => {
    if (e.target.hasAttribute('data-cc-open-settings') || (e.target.tagName !== 'A' && e.target.closest('[data-cc-open-settings]'))) {
      cc.open()
      cc.showSettings()
      cc.switchSettingsLabelsOpen()
      e.preventDefault()
    }
  }
  )
  cc.registerEventListener(document, 'click', e => {
    if (e.target.classList.contains('data-cc-open')) {
      cc.open()
      cc.showSettings()
      cc.switchSettingsLabelsOpen()
      e.preventDefault()
    }
    if (e.target.hasAttribute('data-cc-destroy') || (e.target.tagName !== 'A' && e.target.closest('[data-cc-destroy]'))) {
      cc.setCookieToHideOverlay()
      cc.close()
      e.preventDefault()
    }
    if (e.target.hasAttribute('data-cc-accept-all')) {
      cc.acceptAllScripts()
      cc.setCookieToHideOverlay()
      cc.close()
      e.preventDefault()
    }
  }
  )
  document.body.insertAdjacentHTML('beforeend', '<a title="Gestisci impostazioni cookie" id="cookie-settings-open" data-cc-open="" href="/"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-lock" class="svg-inline--fa fa-user-lock fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"></path></svg></a>')
}
)
